import { Avatar } from '../Avatar/Avatar';
import { LabelArea } from '../Label/LabelArea';
import { DecorativeTag } from '../Tag';
import { SusnetLink } from '../_wrapper/SusnetLink';

type Props = {
  organizationName: string;
  vision: string;
  logo: string;
  uid: string;
  area?: string;
  tags?: string[];
};

export function CardOrganization({ organizationName, vision, logo, uid, area, tags }: Props) {
  return (
    <SusnetLink
      href={`/orgs/${uid}`}
      className='flex w-full max-w-[656px] gap-m__sp rounded-corner-s bg-primary p-xxl__sp shadow-elevation-level1 transition-all hover:shadow-elevation-level3 lg:gap-m lg:p-xxl'
    >
      <Avatar size={64} src={logo} />
      <div className='flex flex-1 flex-col justify-center gap-s__sp lg:gap-s'>
        <div className='text-title-medium__sp font-bold text-primary lg:text-title-medium lg:font-bold'>
          {organizationName}
        </div>
        <div className='text-body-large text-regular'>{vision}</div>
        {area && (
          <div className='flex justify-end'>
            <LabelArea areaText={area} />
          </div>
        )}
        {tags && tags.length > 0 && (
          <ul className='flex w-full flex-wrap items-center gap-s__sp lg:gap-s'>
            {tags.map((tag, index) => (
              <li key={index}>
                <DecorativeTag label={tag} size={'sm'} type={'secondary'} />
              </li>
            ))}
          </ul>
        )}
      </div>
    </SusnetLink>
  );
}
